export const TIER_STYLE = {
  elite: "bg-[#0A2342] text-[#C8A96B]",
  strong: "bg-emerald-100 text-emerald-800",
  opportunity: "bg-amber-100 text-amber-800",
  watch: "bg-slate-200 text-slate-700",
  weak: "bg-red-100 text-red-700",
};

export const TIER_ORDER = ["elite", "strong", "opportunity", "watch", "weak"];

export const money = (v, opts = {}) =>
  v === null || v === undefined || v === "" ? "—" : `$${Number(v).toLocaleString("en-US", { maximumFractionDigits: 0, ...opts })}`;

export const scoreText = (v) => (v === null || v === undefined ? "—" : Number(v).toFixed(1).replace(/\.0$/, ""));

export const pct = (v) => (v === null || v === undefined ? "—" : `${Math.round(v)}%`);

export const dateShort = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";

export const titleCase = (s) =>
  (s || "unknown").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const ASSET_CLASSES = ["apartment", "multifamily", "single_family", "townhome", "condo", "build_to_rent",
  "mobile_home", "commercial", "senior_housing", "affordable_housing", "land", "other", "unknown"];
export const LISTING_TYPES = ["rental", "for_sale", "investment", "unknown"];
export const SUBMARKETS = ["Downtown", "Midtown", "Montrose", "The Heights", "EaDo", "Medical Center", "Galleria/Uptown",
  "Upper Kirby", "Memorial", "Energy Corridor", "Katy", "Sugar Land", "The Woodlands", "Spring", "Cypress", "Clear Lake",
  "Pearland", "Conroe", "Spring Branch", "Pasadena", "Humble", "Missouri City", "unknown"];
